package com.eladfinish.bible.contest.network.logging

import io.ktor.client.plugins.logging.LogLevel

enum class NetworkLogLevel(val ktorLogLevel: LogLevel) {
    ALL(LogLevel.ALL),
    HEADERS(LogLevel.HEADERS),
    BODY(LogLevel.BODY),
    INFO(LogLevel.INFO),
    NONE(LogLevel.NONE)
}
